import _ from 'lodash';
import { isElectron } from '../../utils';

// Device labels dictionaries
// TODO: adapt to more than english and french and test it.
const MIC = ['mic'];
const BUILT_IN = ["sortie", "interne", "built-in"];
const SOUNDFLOWER = ["soundflower (2ch)"];
// const LOOPBACK = ['loopback'];
// const BOSE = ['bose'];


export const detectVolume = (buf, audioContext) => {
  const bufLength = buf.length;
  let sum = 0;
  let x;
  for (let i = 0; i < bufLength; i++) {
    x = buf[i];
    if (Math.abs(x) >= audioContext.clipLevel) {
      audioContext.clipping = true;
      audioContext.lastClip = window.performance.now();
    }
    sum += x * x;
  }

  const rms = Math.sqrt(sum / bufLength);
  return rms * 10;
};


export const float32ToInt16 = (buffer) => {
  let l = buffer.length;
  const buf = new Int16Array(l);

  while (l--) {
    buf[l] = buffer[l] * 0xFFFF;    //convert to 16 bit
  }
  return buf.buffer
};

const _findDefaultInput = (inputs, possibleDefaultInputs) => {
  let defaultInput = null;
  if (inputs) {
    inputs.forEach(d => {
      for (const possibleDefaultInput of possibleDefaultInputs) {
        const match = d.label.toLowerCase().indexOf(possibleDefaultInput) > -1;
        if (match) defaultInput = d;
      }
    });
    if (!defaultInput) defaultInput = _.get(inputs, '[0]');
  }
  return defaultInput;
};

const _findDefaultOutput = (outputs, possibleDefaultOutputs) => {
  let defaultOutput = null;
  if (outputs) {
    outputs.forEach(d => {
      for (const possibleDefaultOutput of possibleDefaultOutputs) {
        const match = d.label.toLowerCase().indexOf(possibleDefaultOutput) > -1;
        if (match) defaultOutput = d;
      }
    });
    if (!defaultOutput) defaultOutput = _.get(outputs, '[0]');
  }

  return defaultOutput;
};

const findSoundflower = inputs => _findDefaultInput(inputs, SOUNDFLOWER);

const findMic = inputs => _findDefaultInput(inputs, MIC);

const findBuiltInOutput = outputs => _findDefaultOutput(outputs, BUILT_IN);

export const findDefaultInput = inputs => {
  return isElectron() ? findSoundflower(inputs) : findMic(inputs);
};

export const findDefaultOutput = outputs => {
  const output = findBuiltInOutput(outputs);
  const playOutput = !!isElectron();
  return {output, playOutput}
};



// WEBPACK FOOTER //
// ./src/containers/Subtitles/utils.js